"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[2919],{

/***/ 2152
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export SidecartGiftingController */
/* harmony import */ var _theme_controllers_cart_utils_controller__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8078);
/* harmony import */ var _customer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5633);



class SidecartGiftingController extends _theme_controllers_cart_utils_controller__WEBPACK_IMPORTED_MODULE_0__.CartUtilsController {
  static targets = [
    "giftForm",
    "giftCheckbox",
    "giftEmail",
    "giftNote",
  ]

  GIFT_RECIPIENT_EMAIL_KEY = 'Recipient email'
  GIFT_MESSAGE_KEY = 'Message'
  GIFT_DISCOUNTS = ['SUBSCRIBER', 'THIS-IS-A-GIFT']

  static values = {
    giftEnabled: Boolean,
    giftInputFilled: { type: Boolean, default: false },
  }

  static outlets = [ 'sidecart-recommendations' ]

  connect() {
    this.debouncedHandleGiftInput = (0,_customer_utils__WEBPACK_IMPORTED_MODULE_1__.debounce)(this.handleGiftInput.bind(this), 600)
    if (this.hasGiftEmailTarget) {
      this.giftEmailTarget.addEventListener('input', this.debouncedHandleGiftInput)
    }
    if (this.hasGiftNoteTarget) {
      this.giftNoteTarget.addEventListener('input', this.debouncedHandleGiftInput)
    }
  }

  disconnect() {
    if (this.hasGiftEmailTarget) {
      this.giftEmailTarget.removeEventListener('input', this.debouncedHandleGiftInput)
    }
    if (this.hasGiftNoteTarget) {
      this.giftNoteTarget.removeEventListener('input', this.debouncedHandleGiftInput)
    }
  }

  handleEnableGifting() {
    this.giftEnabledValue = true
  }

  onCartUpdated() {
    if (!this.cart()?.id) return

    if (this.cart().totalQuantity > 0) {
      this.element.classList.remove('hidden')
      this.render()
    } else {
      this.element.classList.add('hidden')
    }
  }

  render() {
    if (!this.hasGiftCheckboxTarget || !this.hasGiftFormTarget) return

    const giftLine = this.cartLineItems().find(item =>
      item.attributes.some(attr => attr.key === this.GIFT_RECIPIENT_EMAIL_KEY)
    )

    if (giftLine || this.giftEnabledValue) {
      this.giftCheckboxTarget.checked = true
      this.giftFormTarget.classList.remove('hidden')
      if (this.hasSidecartRecommendationsOutlet) {
        this.sidecartRecommendationsOutletElement.parentElement.classList.add('hidden')
      }
      const emailAttr = giftLine?.attributes?.find(attr => attr.key === this.GIFT_RECIPIENT_EMAIL_KEY)
      const noteAttr = giftLine?.attributes?.find(attr => attr.key === this.GIFT_MESSAGE_KEY)
      if (emailAttr?.value && this.hasGiftEmailTarget && this.giftInputFilledValue === false) {
        this.giftEmailTarget.value = emailAttr.value
      }
      if (noteAttr?.value && this.hasGiftNoteTarget && this.giftInputFilledValue === false) {
        this.giftNoteTarget.value = noteAttr.value
      }
      this.giftInputFilledValue = true
    } else {
      this.giftCheckboxTarget.checked = false
      this.giftFormTarget.classList.add('hidden')
      if (this.hasSidecartRecommendationsOutlet) {
        this.sidecartRecommendationsOutletElement.parentElement.classList.remove('hidden')
      }
      if (this.hasGiftEmailTarget) this.giftEmailTarget.value = ''
    }
  }

  async toggleGift(event) {
    if (event.currentTarget.checked) {
      this.giftFormTarget.classList.remove('hidden')
      this.giftEnabledValue = true
    } else {
      this.giftCheckboxTarget.disabled = true
      this.giftFormTarget.classList.add('hidden')
      this.giftEnabledValue = false
      await this.removeGiftDiscounts()
      await this.clearGiftAttributes()
      this.giftCheckboxTarget.disabled = false
    }
  }

  nonGiftAttributes(attributes) {
    return attributes.filter(attr =>
      ![this.GIFT_RECIPIENT_EMAIL_KEY, this.GIFT_MESSAGE_KEY, '__shopify_send_gift_card_to_recipient'].includes(attr.key)
    )
  }

  giftLineItemUpdates() {
    if (!this.cart()?.id) return []
    const email = this.giftEmailTarget?.value?.trim() || ''
    let note = this.giftNoteTarget?.value || ''
    const checked = this.giftCheckboxTarget?.checked
    const validEmail = checked && email && this.isValidGiftEmail(email)
    return this.cartLineItems().map(item => {
      if (validEmail) {
        const giftAttributes = [
          ...this.nonGiftAttributes(item.attributes),
          { key: this.GIFT_RECIPIENT_EMAIL_KEY, value: email },
          { key: this.GIFT_MESSAGE_KEY, value: note }
        ]

        if (item.merchandise.product.productType === 'Gift Card') {
          giftAttributes.push({ key: '__shopify_send_gift_card_to_recipient', value: 'true' })
        }

        return {
          id: item.id,
          attributes: giftAttributes
        }
      } else {
        return {
          id: item.id,
          attributes: this.nonGiftAttributes(item.attributes)
        }
      }
    })
  }

  async handleGiftInput() {
    if (!this.cart()?.id) return
    if (!this.giftCheckboxTarget.checked) return
    const email = this.giftEmailTarget.value.trim()
    if (email && !this.isValidGiftEmail(email)) {
      this.giftEmailTarget.setCustomValidity('Please enter a valid email address')
      this.giftEmailTarget.reportValidity()
      return
    } else {
      this.giftEmailTarget.setCustomValidity('')
    }
    const updates = this.giftLineItemUpdates()
    try {
      await this.addGiftDiscounts()
      await this.updateCart(updates)
    } catch (error) {
      console.error('Failed to update gift attributes:', error)
    }
  }

  async clearGiftAttributes() {
    if (!this.cart()?.id) return
    const updates = this.cartLineItems().map(item => ({
      id: item.id,
      attributes: this.nonGiftAttributes(item.attributes)
    }))
    try {
      await this.updateCart(updates)
    } catch (error) {
      console.error('Failed to clear gift attributes:', error)
    }
  }

  async addGiftDiscounts() {
    const existingCodes = this.cart()?.discountCodes?.map(dc => dc.code) || []
    const discountCodes = [
      ...new Set([...existingCodes, ...this.GIFT_DISCOUNTS])
    ]

    await this.setDiscountCodes(discountCodes)
  }

  async removeGiftDiscounts() {
    const existingCodes = this.cart()?.discountCodes?.map(dc => dc.code) || []
    const discountCodes = existingCodes.filter(
      code => !this.GIFT_DISCOUNTS.includes(code)
    )

    await this.setDiscountCodes(discountCodes)
  }

  isValidGiftEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  isValidForCheckout() {
    if (!this.hasGiftCheckboxTarget || !this.giftCheckboxTarget.checked) return true
    if (!this.hasGiftEmailTarget) return false
    const email = this.giftEmailTarget.value.trim()
    const valid = !!email && this.isValidGiftEmail(email)
    if (!valid) this.giftEmailTarget.reportValidity()
    return valid
  }
}

Stimulus.register("sidecart-gifting", SidecartGiftingController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(2152)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);